import AuthLayout from './AuthLayout'
import WideLayout from './WideLayout'
import MainLayout from './MainLayout'
import CustomLayout from './Custom'

export { AuthLayout as AuthLayout }
export { WideLayout as WideLayout }
export { MainLayout as MainLayout }
export { CustomLayout as CustomLayout }

export default {
  main: MainLayout,
  wide: WideLayout,
  custom: CustomLayout,
  auth: AuthLayout,
}
